export const translations = {
  sv: {
    componentheading: 'Våra priser och villkor för inrikesförsändelser för dig som direktbetalande kund?',
    deliveryscopeheading: 'Endast leveranser inom Sverige',
    resultlistheading: 'Några bra alternativ för dig',
    sizeheading: 'Uppskatta storleken på din försändelse',
    weightheading: 'Uppskatta vikten på din försändelse',
    weightlabel: 'Vikt',
    maxweightlabel: 'Maxvikt',
    maxmeasurementlabel: 'Maxvolym',
    senddirectcta: 'Köp online',
    stampshopcta: 'Till butiken',
    message: '*Vid köp hos valfritt ombud',
    servicePointHeader: 'Eller hitta närmaste serviceställe',
    servicePointLink: 'Hitta Serviceställe',
    realPostcard: 'Köp Riktiga Vykort',
    realPostcardMobile: 'Ladda ner appen',
    ombudHeader: 'Köp via ombud',
  },
  en: {
    componentheading: 'Our prices and terms and conditions for domestic shipments for you as a direct paying customer',
    deliveryscopeheading: 'Deliveries within Sweden only',
    resultlistheading: 'Some suitable options for you',
    sizeheading: 'Estimate the size of your shipment',
    weightheading: 'Estimate the weight of your shipment',
    weightlabel: 'Weight',
    maxweightlabel: 'Max weight',
    maxmeasurementlabel: 'Maximum measurement',
    senddirectcta: 'Buy Online',
    stampshopcta: 'To the Store',
    message: 'When buying from any agent',
    servicePointHeader: 'Find service point',
    servicePointLink: 'Find service point',
    realPostcard: 'Buy Postcards',
    realPostcardMobile: 'Download the app',
    ombudHeader: 'Purchase by agent',
  },
  da: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Kun leveringer indenfor Sverige',
    resultlistheading: 'Nogle passende muligheder for dig',
    sizeheading: 'Anslå størrelsen på din forsendelse',
    weightheading: 'Anslå vægten af din forsendelse',
    weightlabel: 'Vægt',
    maxweightlabel: 'Max vægt',
    maxmeasurementlabel: 'Maks. Volumen',
    senddirectcta: 'Køb Online',
    stampshopcta: 'Til butikken',
    message: 'When buying from any agent',
    servicePointHeader: 'Find nærmeste servicested',
    servicePointLink: 'Find nærmeste servicested',
    realPostcard: 'Køb Riktiga Vykort',
    ombudHeader: 'Køb af agent',
  },
  no: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Kun leveranser innen Sverige',
    resultlistheading: 'Some suitable options for you',
    weightlabel: 'Vekt',
    maxweightlabel: 'Maks vekt',
    maxmeasurementlabel: 'Maks volum',
    senddirectcta: 'Buy shipping in Send Direct',
    stampshopcta: 'Order home stamps from the webshop',
  },
  fi: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Toimitukset vain Ruotsin sisällä',
    resultlistheading: 'Some suitable options for you',
    weightlabel: 'Paino',
    maxweightlabel: 'Max paino',
    maxmeasurementlabel: 'Max äänenvoimakkuus',
    senddirectcta: 'Buy shipping in Send Direct',
    stampshopcta: 'Order home stamps from the webshop',
  },
};

export const markets = {
  se: {
    currency: 'kr',
    country: 'Sweden',
    servicePoint: 'https://www.postnord.se/vara-verktyg/sok-brevlada-eller-servicestalle',
  },
  dk: {
    currency: 'dk',
    country: 'Denmark',
    servicePoint: 'https://www.postnord.dk/varktojer/find-os',
  },
  fi: {
    currency: ' €',
    country: 'Finland',
    servicePoint: '',
  },
  no: {
    currency: 'kr',
    country: 'Norway',
    servicePoint: '',
  },
};
